import React, { useEffect, useState } from "react";
import {
    Switch,
    Route,
    Redirect,
    useHistory,
    useLocation,
} from "react-router-dom";
import { useDispatch } from "react-redux";
import styled from "@emotion/styled";
import { auth } from "../common/utils/auth";
import Login from "../Login";
import Alerts from "../Alerts";
import { ROUTES } from "./utils/constants";
import Header from "../Header";
import { getUserDetails } from "../User/userActions";
import Sidebar from "../Sidebar";
import { GRAY_320, WHITE } from "../common/styles/colors";
import { SPACING_60, SPACING_80 } from "../common/styles/spacing";
import Home from "../Home";

const Layout = styled.div`
    display: grid;
    grid-template-areas: ${
    (props: { loggedIn: boolean }) => (props.loggedIn
        ? ` "Header Header"
                "Sidebar Body"`
        : "\"Body\""
    )};
    grid-template-columns: ${(props) => (props.loggedIn ? `${SPACING_80} 1fr` : "1fr")};
    grid-template-rows:  ${(props) => (props.loggedIn ? `${SPACING_60} 1fr` : "1fr")};
    background: ${GRAY_320};

    height: 100%;
`;

const StyledHeader = styled(Header)`
    grid-area: Header;
    background: ${WHITE};
`;

const StyledSidebar = styled(Sidebar)`
    grid-area: Sidebar;
    background: ${WHITE};
`;

const StyledBody = styled.div`
    grid-area: Body;
`;

export default () => {
    const [loggedIn, setLoggedIn] = useState(false);
    const [initialURL, setInitialURL] = useState(ROUTES.HOME);

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        // sets up a listener to update state if the user has been logged in or out
        auth.onAuthStateChanged(async (_user) => {
            const success = await getUserDetails(dispatch, _user);

            if (success) {
                setLoggedIn(!!_user);
            } else {
                history.push(ROUTES.LOGIN + location.search);
            }
        });

        // We need to save the initial route they go to, to properly redirect the user
        // to the route they visited with the right query params, however sometimes
        // the user might refresh on login which would lead to an invalid state as the page
        // would go back to login
        setInitialURL((location.pathname === ROUTES.LOGIN
            ? ROUTES.HOME
            : location.pathname) + location.search);
    }, []);

    useEffect(() => {
        // When the user state value is updated, check if the user is logged in or not
        // and redirect them to the initial url page if they are
        // and redirect them to the login page if they are not
        history.push(loggedIn ? initialURL : ROUTES.LOGIN);
    }, [loggedIn]);

    return (
        <Layout loggedIn={loggedIn}>
            <Alerts />
            {loggedIn && location.pathname !== ROUTES.LOGIN && (
                <>
                    <StyledHeader />
                    <StyledSidebar />
                </>
            )}
            <StyledBody>
                <Switch>
                    <Route path={ROUTES.LOGIN} render={() => <Login />} />
                    <Route
                        path={ROUTES.HOME}
                        render={() => (loggedIn
                            ? <Home />
                            : <Redirect to={ROUTES.LOGIN} />)}
                    />
                </Switch>
            </StyledBody>
        </Layout>
    );
};
